module.exports = __webpack_public_path__ + "img/fi.a5471749.svg";